import { Box } from "@material-ui/core";
import React, { FC } from "react";
import { CreateButton } from "react-admin";
interface Props {
  title: string;
  hideAddButton?: boolean;
  isShow;
}

const SettingsListTittle = ({ title, hideAddButton, isShow }: Props) => {
  return (
    <Box marginTop="2em">
      <div className="active-prizes-container">{title}</div>
      <Box display="flex" justifyContent="flex-end">
        {hideAddButton || isShow ?
          <CreateButton
          className="add-button"
          label="Add new "
          to="winners/create"
        /> : null}
      </Box>
    </Box>
  );
};

export default SettingsListTittle;
